import React from 'react';

export default function Footer() {
    return (
        <>
            <div className="w-full flex justify-center items-center p-4 md:p-6 whitespace-normal">
                <span className="text-theme-blue text-center text-sm">
                    &copy; 2023 | Todos os direitos são reservados - Raul Santos
                </span>
            </div>
        </>
    );
}
